import { CHECK_TOOLS, type LearningFields } from '@/types/learning'
import type { InvestigationResult, InvestigationStep, ProposedAction } from '@/types/investigation'

// "Save as learning" starts from what the run established: its findings become the symptoms, the
// reads they cite become confirmation checks, and its proposals become the fix. Staff edit it first.
export function learningFromInvestigation(opts: {
  result: InvestigationResult
  steps: InvestigationStep[]
  proposals: ProposedAction[]
  companyId: string | null
}): LearningFields {
  const findings = opts.result.findings ?? []
  const checkTools: readonly string[] = CHECK_TOOLS
  const cited = new Map<number, string>()
  findings.forEach(f => f.evidence.forEach(i => cited.has(i) || cited.set(i, f.title)))
  const confirmationChecks = [...cited.entries()]
    .sort(([a], [b]) => a - b)
    .map(([i, expectation]) => ({ step: opts.steps[i], expectation }))
    .filter(({ step }) => step && !step.isError && checkTools.includes(step.tool))
    .map(({ step, expectation }) => ({ tool: step.tool, args: (step.args ?? {}) as Record<string, unknown>, expectation }))
    .slice(0, 10)

  return {
    kind: 'known_fix',
    scope: opts.companyId ? 'company' : 'global',
    companyId: opts.companyId,
    title: (opts.result.title || opts.result.summary).slice(0, 200),
    symptoms: [opts.result.summary, ...findings.map(f => `- ${f.title}`)].join('\n').slice(0, 4000),
    confirmationChecks,
    fixActions: opts.proposals
      .filter(p => p.status !== 'dismissed')
      .slice(0, 10)
      .map(p => ({ tool: p.tool, args: p.args, summary: p.summary })),
    replyTemplate: opts.result.draftReply,
    notes: '',
    body: ''
  }
}
